import { render } from "./Footer.vue?vue&type=template&id=dbfc3b76&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=dbfc3b76&scoped=true&lang=css"

import exportComponent from "/Users/prateekjha/Projects/movie-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfc3b76"]])

export default __exports__